import {
  ErrorCard,
  type ErrorCardProps,
} from "#app/_ui/components/cards/ErrorCard";
import { Tel } from "#app/_ui/components/media/Tel";
import { hoursOnlineSupport, telOnlineSupport } from "#app/lib/company";
import { toUsaTelHref } from "#app/lib/telephone";
import { LinkButton } from "#ui/link";
import { cx } from "#ui/style.utils";
import { P } from "#ui/typography";

export type PageOutageCardProps = Omit<ErrorCardProps, "children"> & {
  isAuthed?: boolean;
  message?: string;
};

export function PageOutageCard({
  className,
  isAuthed = false,
  message,
  ...props
}: PageOutageCardProps) {
  return (
    <ErrorCard {...props} className={cx("w-full max-w-850px", className)}>
      {message ? (
        <P size="sm" palette="neutral-subtle" className="max-w-702px">
          {message}
        </P>
      ) : (
        <P size="sm" palette="neutral-subtle" className="max-w-702px">
          An unexpected error occurred while processing your request. Steps are
          being taken to resolve this issue. You may contact{" "}
          <LinkButton
            href={isAuthed ? "/contact-us" : "/tech-support"}
            variant="link"
            underline
          >
            Baird Online Support
          </LinkButton>{" "}
          or call{" "}
          <Tel href={telOnlineSupport} hrefFn={toUsaTelHref}>
            {telOnlineSupport}
          </Tel>
          , {hoursOnlineSupport} for assistance.
        </P>
      )}
      <div>
        {isAuthed ? (
          <LinkButton href="/">Go to dashboard</LinkButton>
        ) : (
          <LinkButton href="/sign-in">Ok, got it</LinkButton>
        )}
      </div>
    </ErrorCard>
  );
}
